import api from "./apiService";

export function getVerificationRequests(status = 'pending', page, limit) {
  return api
    .get(`/admin/verifications/verification-requests?status=${status}&page=${page}&limit=${limit}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function getVerificationSummary(filter = 'all') {
  return api
    .get(`/admin/dashboard/verify?filter=${filter}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function getVerificationDetail(id) {
  return api
    .get(`/admin/verifications/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function updateIdStatus(id, data) {
  return api
    .patch(`/admin/verifications/tenants/${id}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function updateAddressStatus(id, data) {
  return api
    .patch(`/admin/verifications/tenants/${id}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function updateAddressStatusWithReason(id, data) {
  return api
    .patch(`/admin/verifications/tenants/${id}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}


//////////////////
// WEBPACK FOOTER
// ./services/verify.js
// module id = null
// module chunks = 